import * as React from "react"
import { Redirect, Route, RouteComponentProps, RouteProps } from "react-router-dom"

import { APPLICATION_URL } from "./ApplicationNavigation"
import { useSessionStore } from "features/Session"

export const WorkspacedRoute: React.FunctionComponent<WorkspacedRouteProps>
  = ({ component: Component, location,  ...rest }) =>
  {
    const customer = useSessionStore(state => state.customer)

    return (
      <Route
        {...rest}
        render={(routeProps) => {
          if (!customer) {
            return (
              <Redirect
                to={{
                  pathname: APPLICATION_URL.base(),
                  state: { redirectUrlAfterLogin: location && location.pathname },
                }}
              />
            )
          }

          return <Component {...routeProps}/>
        }}
      />
    )
  }

interface WorkspacedRouteProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps> | React.ComponentType,
}
